export const AVAILABLE_COUNTRIES = [
    'PL',
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'GB',
];

export const PERSONAL_ID_IGNORE_COUNTRIES = [
    'AT',
    'DE',
    'FR',
    'HU',
    'IE',
    'LU',
];
